import React, {useEffect, useState} from "react";
import Header from "../../components/Header.js";
import * as CampaignService from "../../services/CampaignService.js";
import * as AccountService from "../../services/AccountService.js";
import AllProductsList from "../../components/AllProductsList";
import {FIREBASE_SCREEN_NAMES, HEADER_SIZE, LOCALSTORAGE_ITEMS, PRODUCT_TYPE} from "../../util/Constants";
import * as StorageService from "../../services/StorageService";
import {getAllCampaigns, handleScrollPosition} from "../../util/common";
import analyticsLogEvent from "../../services/FirebaseService";
import {EventBus} from "../../util/EventBus";
import ScanQrToContinue from "../../components/ScanQrToContinue";
import OpenAppInBanner from "../../components/Banner/OpenAppInBanner";
import {getAllAvailableProductsHandler} from "../../handlers/HandlerProducts";
import {useLocation} from "react-router";

function Menu() { // common menu for table order and bar pickup order
    const hasBackButton = StorageService.getItem(LOCALSTORAGE_ITEMS.HAS_BACK_BUTTON) === "true" ? true : false;
    const shopDetails = StorageService.getItem(LOCALSTORAGE_ITEMS.SHOP_DETAILS) ? JSON.parse(StorageService.getItem(LOCALSTORAGE_ITEMS.SHOP_DETAILS)) : null;
    const userEmail = StorageService.getItem(LOCALSTORAGE_ITEMS.USER_EMAIL);
    const shopName = StorageService.getItem(LOCALSTORAGE_ITEMS.SHOP_NAME) ? StorageService.getItem(LOCALSTORAGE_ITEMS.SHOP_NAME) : null;
    const allowOrdering = shopDetails ? (typeof shopDetails.merchantConfig?.allowOrdering !== "undefined" ? shopDetails.merchantConfig?.allowOrdering : null) : false;
    const showDownloadApp = shopDetails ? (typeof shopDetails.merchantConfig?.showDownloadApp !== "undefined" ? shopDetails.merchantConfig?.showDownloadApp : null) : false;
    const useQuery = () => new URLSearchParams(useLocation().search);
    const query = useQuery();
    const readOnly = query.get('readonly');
    const [state, setState] = useState({
        allTagsAndProducts: [],
        extras: null,
        allCampaigns: [],
        loyaltyCampaigns: [],
        shopDetails: null,
        continueInBrowser: StorageService.getItem(LOCALSTORAGE_ITEMS.CONTINUE_IN_BROWSER) ? (StorageService.getItem(LOCALSTORAGE_ITEMS.CONTINUE_IN_BROWSER) + "") === "true" : false,
    });


    useEffect(() => {
        document.body.classList.add("menu-page")
        return () => {
            document.body.classList.remove("menu-page")
        }
    }, []);


    useEffect(() => {
        if (!state.continueInBrowser) {
            if ((showDownloadApp === true || showDownloadApp === null) && (allowOrdering === null || allowOrdering)) {
                document.body.classList.add("blocked")
            }
        } else {
            document.body.classList.remove("blocked");
        }


        getPageContent().then(r => {
            handleScrollPosition();
            analyticsLogEvent("screen_view", {
                firebase_screen: FIREBASE_SCREEN_NAMES.ALL_PRODUCTS,
                firebase_screen_class: FIREBASE_SCREEN_NAMES.ALL_PRODUCTS
            });
        });

    }, []);

    const continueInBrowser = () => {
        StorageService.setItem(LOCALSTORAGE_ITEMS.CONTINUE_IN_BROWSER, "true");
        setState({
            ...state,
            continueInBrowser: true,
        });
        document.body.classList.remove("blocked");
        showWelcomeDialog();
    };

    const showWelcomeDialog = () => {
        let shopDetails = JSON.parse(StorageService.getItem(LOCALSTORAGE_ITEMS.SHOP_DETAILS));
        if (StorageService.getItem(LOCALSTORAGE_ITEMS.CONTINUE_IN_BROWSER) === "true" && shopDetails?.test !== null && shopDetails?.test && StorageService.getItem(LOCALSTORAGE_ITEMS.DEMO_ACCOUNT_MSG_WAS_SHOWN) !== "true") {
            EventBus.dispatch("welcomeDemoModal");
        }
    }

    const getPageContent = async () => {
        let shopDetails = null;
        if (StorageService.getItem(LOCALSTORAGE_ITEMS.SHOP_NAME)) {
            await AccountService.configApp();
            shopDetails = JSON.parse(StorageService.getItem(LOCALSTORAGE_ITEMS.SHOP_DETAILS));
        } else {
            return;
        }


        const allTagsAndProducts = await getAllAvailableProductsHandler(StorageService.getItem(LOCALSTORAGE_ITEMS.SHOP_NAME), PRODUCT_TYPE.DINE_IN);

        const allCampaigns = await getAllCampaigns(StorageService.getItem(LOCALSTORAGE_ITEMS.SHOP_NAME));

        const loyaltyProductsPoints = await getLoyaltyProductsPoints(allCampaigns);
        setState(prev => {
            return {
                ...prev,
                allCampaigns: filterCampaigns(allCampaigns),
                loyaltyCampaigns: loyaltyProductsPoints,
                shopDetails: shopDetails,
                allTagsAndProducts: allTagsAndProducts
            };
        });
    }


    const getLoyaltyProductsPoints = async (allCampaigns) => {
        const loyaltyProductsPoints = {};
        for (let i = 0; i < allCampaigns?.length; i++) {
            const campaign = allCampaigns[i];
            if (campaign.name.indexOf("/loyalty/") > 1) {
                const campaignDetail = await CampaignService.getCampaignDetails(StorageService.getItem(LOCALSTORAGE_ITEMS.SHOP_NAME), campaign.name);
                if (campaignDetail.data.productStamps) {
                    campaignDetail.data.productStamps.forEach(productStamp => {
                        loyaltyProductsPoints[productStamp.pid] = productStamp.points;
                    });
                } else if (!campaignDetail.ok) {
                    if (campaignDetail.data && campaignDetail.data.code === 404) {
                        StorageService.removeItem(LOCALSTORAGE_ITEMS.ALL_CAMPAIGNS);
                        await getPageContent();
                    } else {
                        EventBus.dispatch("genericErrorMsg");
                    }
                    break;
                }
            }
        }
        StorageService.setItem(LOCALSTORAGE_ITEMS.LOYALTY_PRODUCTS_POINTS, JSON.stringify(loyaltyProductsPoints));
        return loyaltyProductsPoints;
    }

    const filterCampaigns = (allCampaigns) => {
        const filteredCampaigns = [];
        for (let i = 0; i < allCampaigns?.length; i++) {
            const campaign = allCampaigns[i];
            if (!campaign.link) { // if campaign is MENU/RESERVATIONS/TAKEAWAY DON'T RETURN IT
                filteredCampaigns.push(campaign);
            }
        }
        return filteredCampaigns;
    }

    return (
        <>
            {
                shopName ?
                    <>
                        <Header
                            headerSize={HEADER_SIZE.MEDIUM}
                            shopDetails={state.shopDetails}
                            hasBackgroundImg={true}
                            headerTitle={state.shopDetails?.title}
                            hasModal={true}
                            hasBackBtn={hasBackButton}
                            hasProfileBtn={true}
                            isDineInMenu={true}
                        />
                        {userEmail &&
                            <AllProductsList
                                allCampaigns={((showDownloadApp === true || showDownloadApp === null) && (allowOrdering === true || allowOrdering === null)) ? state.allCampaigns : null}
                                allTagsAndProducts={state.allTagsAndProducts}
                                loyaltyCampaigns={state.loyaltyCampaigns}
                                hasCartBtn={(StorageService.getItem(LOCALSTORAGE_ITEMS.ORDER_ID))}
                                isDineInMenu={true}
                                readOnly={readOnly}
                            />}


                        {(showDownloadApp === true || showDownloadApp === null) && (allowOrdering === true || allowOrdering === null) ?
                            <OpenAppInBanner
                                continueInBrowser={state.continueInBrowser}
                                onContinueInBrowserClick={continueInBrowser}
                            />
                            : null}

                    </>
                    :
                    <ScanQrToContinue/>
            }
        </>
    );
}

export default Menu;
